import { render, staticRenderFns } from "./CityMain.vue?vue&type=template&id=6b18d070&scoped=true&"
import script from "./CityMain.vue?vue&type=script&lang=js&"
export * from "./CityMain.vue?vue&type=script&lang=js&"
import style0 from "./CityMain.vue?vue&type=style&index=0&id=6b18d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18d070",
  null
  
)

export default component.exports